import { Alert, Button, Card, Space, Table, Typography } from 'antd'
import { toAuditRows } from './taxJurisdictionAuditModel'
import { useWrongJurisdictionInvoicesQuery } from './taxJurisdictionAuditQueries'

const { Paragraph } = Typography

const columns = [
  { title: 'Tenant', dataIndex: 'tenant', key: 'tenant' },
  { title: 'Invoice #', dataIndex: 'invoiceNumber', key: 'invoiceNumber' },
  { title: 'Created', dataIndex: 'createdAt', key: 'createdAt' },
  { title: 'Applied Rate', dataIndex: 'appliedRate', key: 'appliedRate' },
  { title: 'Resolved Location', dataIndex: 'resolvedLocation', key: 'resolvedLocation' },
  { title: 'Property Location', dataIndex: 'propertyLocation', key: 'propertyLocation' },
]

const TaxJurisdictionAuditSection = () => {
  const query = useWrongJurisdictionInvoicesQuery()
  const rows = toAuditRows(query.data ?? [])

  return (
    <Card title="Wrong-Jurisdiction Tax Audit" style={{ maxWidth: 1100 }}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Invoices created with an automatically calculated tax rate whose resolved jurisdiction
          contradicts the job property&apos;s state. Read-only and safe to re-run.
        </Paragraph>

        <div>
          <Button type="primary" onClick={() => query.refetch()} loading={query.isFetching}>
            Run report
          </Button>
        </div>

        {query.isError && (
          <Alert
            type="error"
            showIcon
            message="Failed to run the report"
            description="Run it again to retry."
          />
        )}

        {query.isSuccess && rows.length === 0 && (
          <Alert type="success" showIcon message="No wrong-jurisdiction invoices found" />
        )}

        {query.isSuccess && rows.length > 0 && (
          <Table
            columns={columns}
            dataSource={rows}
            size="small"
            pagination={{ pageSize: 20, hideOnSinglePage: true }}
          />
        )}
      </Space>
    </Card>
  )
}

export default TaxJurisdictionAuditSection
